/* eslint-disable react/prop-types */
/**
 * NoteworthySpotsSection component for Commercial PDP Location Highlights.
 * Displays a list of nearby noteworthy spots with blue checkmark icons
 * and a count indicator showing total spots found.
 */
const NoteworthySpotsSection = ({ spots = [], hasError = false }) => {
  if (hasError) {
    return (
      <div className="location-highlights__section location-highlights__noteworthy-spots">
        <div className="location-highlights__section-header">
          <img
            src="/assets/images/pdp/nearestLocation.png"
            alt=""
            aria-hidden="true"
            className="location-highlights__section-icon-img"
          />
          <h4 className="location-highlights__section-title">Noteworthy Spots</h4>
        </div>
        <p className="location-highlights__error-message">
          Noteworthy spots information is currently unavailable
        </p>
      </div>
    );
  }

  if (!Array.isArray(spots) || spots.length === 0) {
    return (
      <div className="location-highlights__section location-highlights__noteworthy-spots">
        <div className="location-highlights__section-header">
          <img
            src="/assets/images/pdp/nearestLocation.png"
            alt=""
            aria-hidden="true"
            className="location-highlights__section-icon-img"
          />
          <h4 className="location-highlights__section-title">Noteworthy Spots</h4>
          <span className="location-highlights__count-indicator">(0/0)</span>
        </div>
        <p className="location-highlights__empty-message">
          No nearby noteworthy spots found
        </p>
      </div>
    );
  }

  const count = spots.length;

  return (
    <div className="location-highlights__section location-highlights__noteworthy-spots">
      <div className="location-highlights__section-header">
        <img
          src="/assets/images/pdp/nearestLocation.png"
          alt=""
          aria-hidden="true"
          className="location-highlights__section-icon-img"
        />
        <h4 className="location-highlights__section-title">Noteworthy Spots</h4>
        <span className="location-highlights__count-indicator">({count}/{count})</span>
      </div>
      <ul className="location-highlights__spots-list">
        {spots.map((spot, index) => (
          <li key={index} className="location-highlights__spot-item">
            <span className="location-highlights__spot-checkmark" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.25 10.5L1.75 7l0.98-0.98L5.25 8.54l5.02-5.02L11.25 4.5l-6 6z"
                  fill="#118bf4"
                />
              </svg>
            </span>
            <span className="location-highlights__spot-name">{spot.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NoteworthySpotsSection;
